export default {"src":"/_next/static/media/bsd.be8cd84e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};